import { render, staticRenderFns } from "./Stocktakes.vue?vue&type=template&id=5bbd56f6&"
import script from "./Stocktakes.vue?vue&type=script&lang=js&"
export * from "./Stocktakes.vue?vue&type=script&lang=js&"
import style0 from "./Stocktakes.vue?vue&type=style&index=0&id=5bbd56f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports